/**
 * PES传感器相关定义
 */
const SensorKind = {
    105: {
        group: 0,
        text: '空气温度',
        iconindex: '105',
        img: require('../assets/icon/105.png')
    },
    106: {
        group: 0,
        text: '空气湿度',
        iconindex: '106',
        img: require('../assets/icon/106.png')
    },
    107: {
        group: 0,
        text: '风向',
        iconindex: '107',
        img: require('../assets/icon/107.png')
    },
    108: {
        group: 0,
        text: '风速',
        iconindex: '108',
        img: require('../assets/icon/108.png')
    },
    109: {
        group: 0,
        text: '雨量',
        iconindex: '109',
        img: require('../assets/icon/109.png')
    },
    110: {
        group: 0,
        text: '二氧化碳',
        iconindex: 'default',
        img: require('../assets/icon/110.png')
    },
    111: {
        group: 0,
        text: '空气PM2.5',
        iconindex: 'default',
        img: require('../assets/icon/105.png')
    },
    112: {
        group: 0,
        text: '空气PM10',
        iconindex: '105',
        img: require('../assets/icon/105.png')
    },
    113: {
        group: 0,
        text: '光照强度',
        iconindex: '113',
        img: require('../assets/icon/113.png')
    },
    114: {
        group: 0,
        text: '光照紫外线',
        iconindex: 'default',
        img: require('../assets/icon/113.png')
    },
    149: {
        group: 0,
        text: '蒸发量',
        iconindex: '149',
        img: require('../assets/icon/149.png')
    },
    147: {
        group: 0,
        text: '大气压',
        iconindex: '147',
        img: require('../assets/icon/147.png')
    },
    148: {
        group: 0,
        text: '光合有效辐射',
        iconindex: '148',
        img: require('../assets/icon/default.png')
    },
    151: {
        group: 0,
        text: '氧气浓度',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    167: {
        group: 0,
        text: '露点温度',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    119: {
        group: 1,
        text: '水体温度',
        iconindex: '119',
        img: require('../assets/icon/119.png')
    },
    120: {
        group: 1,
        text: '水体pH值',
        iconindex: '120',
        img: require('../assets/icon/120.png')
    },
    121: {
        group: 1,
        text: '水体电导率',
        iconindex: '121',
        img: require('../assets/icon/121.png')
    },
    122: {
        group: 1,
        text: '水体电导率',
        iconindex: '122',
        img: require('../assets/icon/122.png')
    },
    123: {
        group: 1,
        text: '水体盐度',
        iconindex: '123',
        img: require('../assets/icon/123.png')
    },
    124: {
        group: 1,
        text: '水浊度',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    150: {
        group: 1,
        text: '溶解氧',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    125: {
        group: 2,
        text: '土壤温度',
        iconindex: '125',
        img: require('../assets/icon/125.png')
    },
    126: {
        group: 2,
        text: '土壤湿度',
        iconindex: '126',
        img: require('../assets/icon/126.png')
    },
    127: {
        group: 2,
        text: '土壤pH值',
        iconindex: '127',
        img: require('../assets/icon/127.png')
    },
    128: {
        group: 2,
        text: '土壤盐分',
        iconindex: '128',
        img: require('../assets/icon/128.png')
    },
    129: {
        group: 2,
        text: '土壤电导率',
        iconindex: '129',
        img: require('../assets/icon/129.png')
    },
    130: {
        group: 2,
        text: '土壤重金属N',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    131: {
        group: 2,
        text: '土壤重金属P',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    137: {
        group: 2,
        text: '有机质含量',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    138: {
        group: 2,
        text: '全氮',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    139: {
        group: 2,
        text: '有效磷',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    140: {
        group: 2,
        text: '速效钾',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    141: {
        group: 2,
        text: '土壤容重',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    146: {
        group: 2,
        text: '海拔',
        iconindex: 'default',
        img: require('../assets/icon/default.png')
    },
    152: {
        group: 2,
        text: '土壤温度40CM',
        iconindex: '125',
        img: require('../assets/icon/125.png')
    },
    153: {
        group: 2,
        text: '土壤湿度40CM ',
        iconindex: '126',
        img: require('../assets/icon/126.png')
    },
    154: {
        group: 2,
        text: '土壤PH值40CM',
        iconindex: '127',
        img: require('../assets/icon/127.png')
    },
    155: {
        group: 2,
        text: '土壤盐分40CM',
        iconindex: '128',
        img: require('../assets/icon/128.png')
    },
    156: {
        group: 2,
        text: '土壤电导率40CM',
        iconindex: '129',
        img: require('../assets/icon/129.png')
    },
    157: {
        group: 2,
        text: '土壤温度60CM',
        iconindex: '125',
        img: require('../assets/icon/125.png')
    },
    158: {
        group: 2,
        text: '土壤湿度60CM',
        iconindex: '126',
        img: require('../assets/icon/126.png')
    },
    159: {
        group: 2,
        text: '土壤PH值60CM',
        iconindex: '127',
        img: require('../assets/icon/127.png')
    },
    160: {
        group: 2,
        text: '土壤盐分60CM',
        iconindex: '128',
        img: require('../assets/icon/128.png')
    },
    161: {
        group: 2,
        text: '土壤电导率60CM',
        iconindex: '129',
        img: require('../assets/icon/129.png')
    },
    162: {
        group: 2,
        text: '土壤温度80CM',
        iconindex: '125',
        img: require('../assets/icon/125.png')
    },
    163: {
        group: 2,
        text: '土壤湿度80CM',
        iconindex: '126',
        img: require('../assets/icon/126.png')
    },
    164: {
        group: 2,
        text: '土壤PH值80CM',
        iconindex: '127',
        img: require('../assets/icon/127.png')
    },
    165: {
        group: 2,
        text: '土壤盐分80CM',
        iconindex: '128',
        img: require('../assets/icon/128.png')
    },
    166: {
        group: 2,
        text: '土壤电导率80CM',
        iconindex: '129',
        img: require('../assets/icon/129.png')
    }
}
const getIcon = (res) => {
   // console.log("ressss",res)
    var node = SensorKind[res]
    if (node) {
        return node.img
    }
    return require('../assets/icon/default.png')
}
export {
    getIcon,
    SensorKind
}
